module.exports = __webpack_public_path__ + "media/images/features/support/thumb-voice-3-2547c9f555329edde2f1b929f4e868ec.jpg";